module.exports.urlFor = (type, slug) => {
  switch (type) {
    case "DatoCmsBrand":
      return `/brand/${slug}`
    default:
      return `/${slug}`
  }
}
